var map = {
	"./1.svg": 906,
	"./10.svg": 907,
	"./11.svg": 908,
	"./12.svg": 909,
	"./13.svg": 910,
	"./14.svg": 911,
	"./15.svg": 912,
	"./16.svg": 913,
	"./17.svg": 914,
	"./2.svg": 915,
	"./3.svg": 916,
	"./4.svg": 917,
	"./5.svg": 918,
	"./6.svg": 919,
	"./7.svg": 920,
	"./8.svg": 921,
	"./9.svg": 922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;